import { QrCode } from 'lucide-react';
import { TemplateMeta } from './TemplateParts';

export default function GiftListAtelier({ data }) {
  const {
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    showSiteLink,
    siteUrl,
    showQrCode,
    textColor,
    textShadow,
    accentColor,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0 p-5 md:p-6 flex">
      <div className="w-full rounded-[26px] border border-white/24 bg-[#1D141A]/72 backdrop-blur-[1px] shadow-[0_22px_44px_rgba(0,0,0,0.35)] p-5 md:p-6 grid grid-cols-[1.5fr_1fr] gap-4">
        <div className="flex flex-col">
          <div className="flex items-center gap-2 text-white/90">
            <span className="rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.16em] font-semibold bg-white/12 border border-white/20">
              Lista de presentes
            </span>
            {isPremium ? (
              <span className="rounded-full px-2 py-1 text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#FFF4E5] text-[#9C784C]">Premium</span>
            ) : null}
          </div>

          <h4 className="mt-4 text-[2rem] md:text-[2.7rem] font-bold leading-[1.04]" style={titleStyle}>
            {coupleName}
          </h4>

          <div className="mt-3">
            <TemplateMeta rows={rows} textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} />
          </div>

          {shortPhrase ? (
            <p className="mt-4 text-sm md:text-base" style={bodyStyle.style}>{shortPhrase}</p>
          ) : null}

          {ctaText ? (
            <div className="mt-auto rounded-xl border border-white/25 bg-black/20 px-3 py-2 text-xs uppercase tracking-[0.14em] font-semibold" style={{ color: textColor, textShadow }}>
              {ctaText}
            </div>
          ) : null}
        </div>

        <div className="flex flex-col justify-between rounded-2xl border border-white/28 bg-white/12 p-3">
          {showQrCode ? (
            <div className="mx-auto mt-2 rounded-xl p-3 bg-white/95 border border-white/60">
              <QrCode className="w-14 h-14 text-[#1C1C1C]" />
            </div>
          ) : (
            <div className="mt-2" />
          )}

          {showSiteLink ? (
            <div className="rounded-lg bg-white/88 px-2 py-2">
              <p className="text-[10px] uppercase tracking-[0.12em] font-semibold" style={{ color: accentColor || '#9A6B65' }}>
                Link da lista
              </p>
              <p className="text-[11px] truncate text-[#1C1C1C]">{siteUrl || 'vireinoiva.com.br'}</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
